import httpClient from "./httpClient";

const prefix = "/proceedings";
const documentTypePrefix = "/document-type";

export async function fetchDocumentTypes() {
  return (await httpClient.get(`${prefix}/find-documents`)).data;
}

export async function paginateDocumentTypes(query: string) {
  return (await httpClient.get(`${documentTypePrefix}/paginated?${query}`)).data;
}

export async function deleteDocumentType(id: number) {
  return (await httpClient.delete(`${documentTypePrefix}/${id}`)).data;
}

export async function saveDocumentType(data: {
  name: string;
  obligatory: boolean;
  maxDayToUpload?: number;
}) {
  return (await httpClient.post(`${documentTypePrefix}/save`, data)).data;
}

export async function updateDocumentType(
  id: number,
  data: { name?: string; obligatory?: boolean; maxDayToUpload?: number }
) {
  return (await httpClient.patch(`${documentTypePrefix}/${id}`, data)).data;
}